import React, {useMemo, useCallback, useState, useEffect} from "react";
import Registration from "../Registration/Loadable";
import Login from "../Login/Loadable";
import {LoginFormData, SignUpFormData} from "../../containers/RegistrationLoginPage/types";
import {MainContainer, SectionContainer} from "../CommonStyled/widgets/Styled";
import {TabsHeader} from "../Registration/widgets/Styled";
import Card from "../WidgetCard";
import {getPageType, LOGIN_SIGN_UP_TAB_CONFIG} from "../../containers/RegistrationLoginPage/utils";
import {useLocation, useHistory} from "react-router";
import {validateField} from "../../utils/validation";
// import RegistrationFormContentLoader from "../Registration/widgets/RegistrationFormContentLoader";
import SignUpFormContentLoader from "../Registration/widgets/SignUpFormContentLoader";
import LoginFormContentLoader from "../Registration/widgets/LoginFormContentLoader";
import RedirectToURL from "../Static/RedirectToURL";
import {CROP_WINDOW_HEIGHT, CROP_WINDOW_WIDTH} from "../UserImageUploader/utils";

const Tabs: React.FC = () => {
    const location = useLocation();
    const {activePage} = getPageType(location.pathname);
    const history = useHistory();
    const redirectCallback = useCallback(
        (path) => {
            if (path !== false) {
                history.push(path);
            }
        },
        [history],
    );
    return (
        <TabsHeader>
            {LOGIN_SIGN_UP_TAB_CONFIG.map((val, index) => {
                const active = val.pageName === activePage ? "active" : "";
                if (!val.showOn.includes(activePage)) {
                    return null;
                }

                return (
                    <label
                        onClick={() => redirectCallback(val.path)}
                        key={index}
                        className={active}
                    >
                        {val.name}
                    </label>
                );
            })}
        </TabsHeader>
    );
};

interface Props {
    signUpPageData?: SignUpFormData;
    showLogin: boolean;
    showSignUp: boolean;
    showContentLoader: boolean;
    loginPageData?: LoginFormData;
}
const RegistrationLogin: React.FC<Props> = ({
    signUpPageData,
    showLogin,
    showSignUp,
    showContentLoader,
    loginPageData,
}: Props) => {
    const location = useLocation();
    const [showTabs, setShowTabs] = useState(true);
    const {pathname} = location;

    const query = new URLSearchParams(location.search);
    //this paramter is used to hide the login signup tabs in app on signup page only
    const hideTabsInApp = query.get("hideTabsInApp");

    useEffect(() => {
        if (hideTabsInApp) {
            setShowTabs(false);
        }
    }, [hideTabsInApp]);

    const jsx = useMemo(() => {
        const {pageStatus} = getPageType(pathname);
        const {isLogin} = pageStatus;

        if (
            isLogin &&
            (showContentLoader || !validateField(loginPageData) || !!loginPageData?.redirectUrl)
        ) {
            return (
                <>
                    {loginPageData?.redirectUrl && (
                        <RedirectToURL url={loginPageData.redirectUrl} />
                    )}
                    <LoginFormContentLoader />
                </>
            );
        }
        if (
            !isLogin &&
            (showContentLoader || !validateField(signUpPageData) || !!signUpPageData?.redirectUrl)
        ) {
            return (
                <>
                    {signUpPageData?.redirectUrl && (
                        <RedirectToURL url={signUpPageData.redirectUrl} />
                    )}
                    <SignUpFormContentLoader />
                </>
            );
        }

        return (
            <>
                {!isLogin && showSignUp && signUpPageData && (
                    <Registration
                        signUpPageData={signUpPageData}
                        cropSize={{
                            width: CROP_WINDOW_WIDTH,
                            height: CROP_WINDOW_HEIGHT,
                        }}
                    />
                )}
                {isLogin && showLogin && loginPageData && (
                    <Login loginPageData={loginPageData} setShowTabs={setShowTabs} />
                )}
            </>
        );
    }, [pathname, showContentLoader, signUpPageData, loginPageData, showSignUp, showLogin]);

    return (
        <MainContainer>
            <SectionContainer
                sectionContainerStyle={{
                    mobile: {maxWidth: ""},
                    laptop: {maxWidth: "800px", margin: "20px auto 0 auto"},
                }}
            >
                <Card
                    cardStyle={{
                        mobile: {padding: "0"},
                        laptop: {padding: "0"},
                    }}
                    widgetCardStyle={{
                        mobile: {boxShadow: "none"},
                        laptop: {
                            boxShadow:
                                "0 2px 4px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.18);",
                            borderRadius: "8px",
                        },
                    }}
                >
                    {showLogin && showSignUp && showTabs && <Tabs />}
                    {jsx}
                </Card>
            </SectionContainer>
        </MainContainer>
    );
};
export default RegistrationLogin;
